module.exports = __webpack_public_path__ + "img/4.dd9e80e9.jpg";